// utils
import axios from 'utils/axios';

// ----------------------------------------------------------------------

function jwtDecode(token: string) {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
        window
            .atob(base64)
            .split('')
            .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
            .join('')
    );

    return JSON.parse(jsonPayload);
}

// ----------------------------------------------------------------------

export const isValidToken = (accessToken: string) => {
    if (!accessToken) {
        return { status: false };
    }

    const decoded = jwtDecode(accessToken);
    const currentTime = Date.now() / 1000;

    return { status: decoded.exp > currentTime, user: decoded.user };
};

// ----------------------------------------------------------------------

export const tokenExpired = (exp: number) => {
    // eslint-disable-next-line prefer-const
    let expiredTimer;

    const currentTime = Date.now();

    // Test token expires after 10s
    // const timeLeft = currentTime + 10000 - currentTime; // ~10s
    const timeLeft = exp * 1000 - currentTime;

    clearTimeout(expiredTimer);

    expiredTimer = setTimeout(() => {
        alert('Token expired');

        sessionStorage.removeItem('accessToken');

        window.location.href = '/login';
    }, timeLeft);
};

// ----------------------------------------------------------------------

export const setSession = (accessToken: string | null) => {
    if (accessToken) {
        sessionStorage.setItem('accessToken', accessToken);

        axios.defaults.headers.common.Authorization = `JWT ${accessToken}`;

        // This function below will handle when token is expired
        const { exp } = jwtDecode(accessToken); // ~3 days by minimals server
        tokenExpired(exp);
    } else {
        sessionStorage.removeItem('accessToken');

        delete axios.defaults.headers.common.Authorization;
    }
};

// ----------------------------------------------------------------------

export const setUserSession = (userString: string | null) => {
    if (userString) {
        sessionStorage.setItem('user', userString);
    } else {
        sessionStorage.removeItem('user');
    }
}